/**
 * A SHORT LIST OF NAMED FACTS. 09 §5.4 T12's sibling rule, one level down.
 *
 * A detail screen is a handful of labelled values, and the two ways it goes wrong are a table with
 * two columns (which acquires sorting, filtering and a totals row it has no use for) and a
 * paragraph (which cannot be scanned). A description list is neither, and it is what a screen reader
 * announces as a term and its definition.
 *
 * A `null` value is rendered as a written absence, never as an empty cell: 09 §9.2 keeps null
 * visually distinct from zero, and the same rule applies to a fact that has no value yet.
 */

import type { ReactNode } from 'react';

export interface Fact {
  readonly labelHe: string;
  /** `null` ⇒ the value does not exist, and the list says so in words. */
  readonly value: ReactNode | null;
  /** Shown when `value` is null. Defaults to the general written absence. */
  readonly absentHe?: string;
}

export function FactList({ facts }: { readonly facts: readonly Fact[] }): JSX.Element {
  return (
    <dl className="facts">
      {facts.map((fact) => (
        <div key={fact.labelHe} className="facts__row">
          <dt className="facts__label">{fact.labelHe}</dt>
          <dd className="facts__value">
            {fact.value === null ? (
              <span className="facts__absent">{fact.absentHe ?? 'אין נתון'}</span>
            ) : (
              fact.value
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
}
